import { render, staticRenderFns } from "./ObjectFiles.vue?vue&type=template&id=2b0b0127&scoped=true"
import script from "./ObjectFiles.vue?vue&type=script&lang=js"
export * from "./ObjectFiles.vue?vue&type=script&lang=js"
import style0 from "./ObjectFiles.vue?vue&type=style&index=0&id=2b0b0127&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0b0127",
  null
  
)

export default component.exports